"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/*
 @param {function} task Should return a promise
 @param {number} wait Milliseconds

 This function returns a promise that will be rejected with 'debounced' if
 called again before the wait time has elapsed. If not, the promise will be resolved
 by the task.
 */

var debounceAsPromise = function debounceAsPromise(task, wait) {
  if (wait === 0) {
    return task;
  }
  var cancel = function cancel() {};
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    cancel();
    return new Promise(function (resolve, reject) {
      var timer = setTimeout(function () {
        return task.apply(void 0, args).then(function (data) {
          return resolve(data);
        })["catch"](function (error) {
          return reject(error);
        });
      }, wait);
      cancel = function cancel() {
        clearTimeout(timer);
        reject('debounced');
      };
    });
  };
};
var _default = exports["default"] = debounceAsPromise;